// AFTER: ProtectedRoute.jsx
import { Navigate } from "react-router-dom";

export default function ProtectedRoute({ children }) {
    const accessToken = localStorage.getItem("vendor_access_token");
    const refreshToken = localStorage.getItem("vendor_refresh_token");

    // Allow access if EITHER token exists. 
    // If access token is expired/missing, api.js will use the refresh token.
    return (accessToken || refreshToken) ? children : <Navigate to="/login" replace />;
}